<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
    <div class="grid form-group">
      <!-- POLITICAS -->
      <div class="col-6">
        <div class="div-form">
          <label
            >*
            {{
              "FLUJOVENTASPOLITICASCONFIGURADAS.LBL_POLITICAS"
                | translate
            }}</label
          >
          <p-multiSelect
            id="politicas"
            name="politicas"
            [options]="listaPoliticasMultiSelect"
            filter="filter"
            defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
            selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate }}"
            formControlName="idsPoliticas"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
            optionValue="value"
            optionLabel="label"
          ></p-multiSelect>
          <div
            class="p-message p-messages-error p-corner-all"
            *ngIf="submitted && f.idsPoliticas.invalid"
          >
            {{
              "FLUJOVENTASPOLITICASCONFIGURADAS.LBL_POLITICAS"
                | translate
            }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
       </div>
    </div>

    <!-- BOTON AGREGAR -->
    <div class="grid text-center">
      <div class="form-group col-12" *ngIf="!guardando">
        <button
          icon="fa fa-plus"
          label="{{ 'BTN_AGREGAR' | translate }}"
          type="button"
          (click)="onSubmit()"
          pButton
        ></button>
      </div>

      <div class="form-group col-12" *ngIf="guardando">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
          <span>{{ "LBL_PROCESANDO" | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <!-- BUSCADOR -->
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6"></div>
    <div class="col-12 md:col-6 lg:col-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="tabPolConf.filterGlobal($any ($event.target).value, 'contains' )"
             [(ngModel)]="busqueda" (change)="setBusqueda()">
    </div>
  </div>

  <!-- LISTADO POLITICAS -->
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        [columns]="columnas"
        #tabPolConf
        [value]="listaPoliticasConfiguradas"
        selectionMode="single"
        dataKey="codigoPolitica"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
        [loading]="guardando"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.codigoPolitica }}</td>
            <td>{{ row.politica }}</td>
            <td>{{ row.categoriaPolitica }}</td>
            <td>{{ row.politicaModalidad }}</td>
            <td class="text-center">
              <div class="btn-group" role="group" *ngIf="!row.indicadorPoliticaGlobal" >
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_INHABILITAR' | translate }}"
                  pButton
                  (click)="inhabilitar(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="form-politicas-configuradas">
  <p-footer>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      label="{{ 'LBL_NO' | translate }}"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      label="{{ 'LBL_SI' | translate }}"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
